import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

import { LeistungProvider } from '../../providers/leistung/leistung';
import { RhynoApiProvider } from '../../providers/rhyno-api/rhyno-api';

import { SelectMitarbeiterPage } from '../select-mitarbeiter/select-mitarbeiter';
import { SelectProjectPage } from '../select-project/select-project';
import { SelectLeistungPage } from '../select-leistung/select-leistung';
import { LeistungstextPage } from '../leistungstext/leistungstext';


@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {

Mitarbeiter = [];

  constructor(public navCtrl: NavController, 
  	public leistungCtrl: LeistungProvider,
    public navParams: NavParams, 
    private rhynoApi: RhynoApiProvider) {

    console.log(navParams.data)
    if (navParams.data.presettings){
      if (navParams.data.presettings.Datum){
        this.leistungCtrl.leistung.Datum = navParams.data.presettings.Datum;

      }
      if (this.rhynoApi._UserAccount){
        this.leistungCtrl.leistung.Mitarbeiter = this.rhynoApi._UserAccount.Mitarbeiter;
        this.leistungCtrl.leistung.MitarbeiterName = this.rhynoApi._UserAccount.Name;
      }
    }
    
  }
  
  ionViewWillEnter(pra){
    console.log(pra)
    this.leistungCtrl.prefillProject(true);
  }

  
  createLeistung(){
  	this.leistungCtrl.createLeistung(this.navCtrl); 

    /*.subscribe(data => {
      var respData = JSON.parse(data._body);

      if (respData.success){
        this.navCtrl.pop()
       }
    });*/
  }

  openPageMitarbeiterProject(){
  	this.navCtrl.push(SelectMitarbeiterPage, {create:true});
  }

  openPageSelectProject(){
  	this.navCtrl.push(SelectProjectPage, {create:true});
  }

  openPageSelectLeistung(){
  	this.navCtrl.push(SelectLeistungPage, {create:true});
  }

  openPageLeistungstext(){
  	this.navCtrl.push(LeistungstextPage, {create:true});
  }
  openPageSelectMitarbeiter(){
  	this.navCtrl.push(SelectMitarbeiterPage, {create:true});
  }

  

}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts